import {useState} from "react";
import {View} from "../helpers/interfaceHelper";

const useView = (): [
    string, (p: string, v: View[]) => void
  ] => {
      const [view, setView] = useState<string>("");
      
      const setChosenView = (view: string, dbViews: View[]) => {
        if (isNaN(parseInt(view))) {
          if (dbViews) {
            const chosenView: View | undefined = dbViews.find(v => v.name === view);
            if (chosenView !== undefined) {
              setView(chosenView.id);
            } else {
              setView("");
            }
          }
        } else {
          setView(view);
        }
      }
    
      return [view, setChosenView];
  }

  export default useView;